export default {
  'id': 1,
  'number': '000001',
  'created_date': '2018-05-01 10:09',
  'pickup_time': '2018-05-01 12:00',
  'status': 'completed',
  'type': 'group',
  'reward_points': 1,
  'currency': 'lei',
  'delivery': {
    'id': 'pickup',
    'type': 'Pick up'
  },
  'payment': {
    'id': 'cash',
    'type': 'Cash on Delivery'
  },
  'totals': {
    'subtotal': '32.5',
    'discount': '-10',
    'shipping': '5',
    'total': '27.5'
  },
  'comments': '',
  'customer': {
    'id': 1,
    'name': 'Iopescu Viorel',
    'phone': '+44 777 111 222',
    'email': 'iovio@gmail.com'
  },
  'address': {
    'billing': {
      'id': 10,
      'type': 'billing',
      'street': 'Zorelelor 12',
      'city': 'Oradea',
      'state': 'Bihor',
      'country': 'RO'
    },
    'shipping': {
      'id': 11,
      'type': 'shipping',
      'street': 'Zorelelor 12',
      'city': 'Oradea',
      'state': 'Bihor',
      'country': 'RO'
    }
  },
  'products': [
    {
      'customer': {
        'name': 'Viorel'
      },
      'items': [
        {
          'id': 1,
          'name': 'Cappucinno',
          'quantity': 3,
          'price': 7.00,
          'instructions': 'Please use coconut milk.',
          'category': {
            'category_id': 7,
            'name': 'Beverages'
          },
          'options': [
            {
              'id': 3,
              'name': 'Extra extresso shot',
              'price': 3
            }
          ]
        },
        {
          'id': 1,
          'name': 'Chocolate Chip Cookie',
          'quantity': 1,
          'price': 4.50,
          'instructions': '',
          'category': {
            'category_id': 8,
            'name': 'Cookies'
          },
          'options': []
        }
      ]
    },
    {
      'customer': {
        'name': 'Rozi-'
      },
      'items': [
        {
          'id': 1,
          'name': 'Cappucinno',
          'quantity': 1,
          'price': 7.00,
          'instructions': '',
          'category': {
            'category_id': 7,
            'name': 'Beverages'
          },
          'options': []
        }
      ]
    }
  ],
  'history': [
    {
      'date': '2018-07-15',
      'status': 'pending',
      'comment': '',
      'customer_notified': 'yes'
    },
    {
      'date': '2018-07-15',
      'status': 'processing',
      'comment': '',
      'customer_notified': 'no'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/components/Dashboard/Views/Orders/order.js